export const DATA = {
  GX: {
    GRID_POWER: {
      KEY: 'GRID_POWER',
      LABEL: 'Grid Power',
      COLOR: '#007CDC',
    },
    HVAC_POWER: {
      KEY: 'HVAC_POWER',
      LABEL: 'HVAC Power',
      COLOR: '#FF6B21',
    },
    EV_CHARGER_POWER: {
      KEY: 'EV_CHARGER_POWER',
      LABEL: 'EV Charger Power',
      COLOR: '#00996C',
    },
    SOLAR_POWER: {
      KEY: 'SOLAR_POWER',
      LABEL: 'Solar Power',
      COLOR: '#D19F00',
    },
    BATTERY_DISCHARGE_POWER: {
      KEY: 'BATTERY_DISCHARGE_POWER',
      LABEL: 'Battery Discharge Power',
      COLOR: '#815800',
    },
    BATTERY_CHARGE_POWER: {
      KEY: 'BATTERY_CHARGE_POWER',
      LABEL: 'Battery Charge Power',
      COLOR: '#D00B89',
    },
    GENERATOR_POWER: {
      KEY: 'GENERATOR_POWER',
      LABEL: 'Generator Power',
      COLOR: '#9700f5',
    },
    TOTAL_LOAD: {
      KEY: 'TOTAL_LOAD',
      LABEL: 'Total Load',
      COLOR: '#3A4A50',
    },
  },
  TEMP: {
    CURRENT: {
      KEY: 'CURRENT',
      LABEL: 'Current Temperature',
      COLOR: '#3A4A50',
    },
    OUTSIDE: {
      KEY: 'OUTSIDE',
      LABEL: 'Outside Temperature',
      COLOR: '#e7d921',
    },
    UPPER_BOUND: {
      KEY: 'UPPER_BOUND',
      LABEL: 'Upper Bounds',
      COLOR: '#ef4444',
    },
    LOWER_BOUND: {
      KEY: 'LOWER_BOUND',
      LABEL: 'Lower Bounds',
      COLOR: '#41A7C9',
    },
  },
  ACTIVITY: {
    HEATING: {
      KEY: 'HEATING',
      LABEL: 'Heating',
      COLOR: 'rgba(255, 99, 132, 1)',
      BAND: 'rgba(255, 99, 132, 0.15)',
    },
    COOLING: {
      KEY: 'COOLING',
      LABEL: 'Cooling',
      COLOR: 'rgba(54, 162, 235, 1)',
      BAND: 'rgba(54, 162, 235, 0.15)',
    },
    FAN: {
      KEY: 'FAN',
      LABEL: 'Fan',
      COLOR: 'rgba(192, 192, 192, 1)',
      BAND: 'rgba(192, 192, 192, 0.2)',
    },
  },
};
